import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "./image/justseologo.png";
import { Link } from "react-router-dom";
import LoginPopup from "../LoginPopup/LoginPopup";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [seoDropdownOpen, setSeoDropdownOpen] = useState(false);
  const [digitalDropdownOpen, setDigitalDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const [showLoginPopup, setShowLoginPopup] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Close dropdown when switching from mobile to desktop view
      if (window.innerWidth > 768) {
        setSeoDropdownOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setIsOpen(!isOpen);
    // Close SEO dropdown when mobile menu is closed
    if (isOpen) {
      setSeoDropdownOpen(false);
    }
  };

  const toggleSeoDropdown = (e) => {
    // Prevent default only for mobile to avoid navigation
    if (isMobile) {
      e.preventDefault();
    }
    setSeoDropdownOpen(!seoDropdownOpen);
  };

  const toggleDigitalDropdown = (e) => {
  if (isMobile) {
    e.preventDefault();
  }
  setDigitalDropdownOpen(!digitalDropdownOpen);
};

  // Close dropdown when clicking outside (for desktop)
  const handleClickOutside = (e) => {
    if (!e.target.closest(".nav-item-with-dropdown")) {
      setSeoDropdownOpen(false);
    }
  };

  // Add event listener for clicks outside dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  

  return (
    <>
      {/* Top Bar */}
      <div className="header-top">
        <div className="header-left">
          🏆 We Won The Best SEO Agency of the year in 2024–25
        </div>
        <div className="header-right">
          <span>
            Email: <a href="mailto:digital@justseo.in">digital@justseo.in</a>
          </span>
          <span>
            Call : <a href="tel:+919155599968">+91 9155599968</a>
          </span>
          <span>
            Sales : <a href="tel:+912269710459">+91 2269710459</a>
          </span>
          {/* <a
            href="https://wa.me/+912269710459"
            className="whatsapp-button"
            target="_blank"
            rel="noreferrer"
          >
            💬 Chat on WhatsApp
          </a> */}
        </div>
      </div>

      {/* Main Header */}
      <header className="site-header">
        <div className="logo">
          <Link to='/'><img src={logo} alt="Company Logo" /></Link>
        </div>
        <nav className={isOpen ? "nav-menu active" : "nav-menu"}>
          <a href="/home">HOME</a>

          {/* SEO Dropdown */}
          <div
            className="nav-item-with-dropdown"
            onMouseEnter={() => !isMobile && setSeoDropdownOpen(true)}
            onMouseLeave={() => !isMobile && setSeoDropdownOpen(false)}
          >
            <a
              href="#seo"
              onClick={toggleSeoDropdown}
              aria-expanded={seoDropdownOpen}
              aria-haspopup="true"
            >
              SEO ▼{" "}
              {isMobile && isOpen && (
                <span className="dropdown-indicator">
                  {seoDropdownOpen ? "−" : "+"}
                </span>
              )}
            </a>
            {seoDropdownOpen && (
              <div className="seo-dropdown">
                <div className="dropdown-section">
                  <h3>360°</h3>
                  <a href="#">Custom SEO</a>
                  <a href="#">Local SEO</a>
                  <a href="#">SEO for Small Businesses</a>
                  <a href="#">Global SEO</a>
                  <a href="#">Enterprises SEO</a>
                  <a href="#">GMB Service</a>
                  <a href="#">SEO Marketing Agency India</a>
                </div>

                <div className="dropdown-section">
                  <h3>Consultancy</h3>
                  <a href="#">SEO Consultancy</a>
                  <a href="#">Free Website Audit</a>
                  <a href="#">Technical SEO Audit</a>
                </div>

                <div className="dropdown-section">
                  <h3>Backlinks</h3>
                  <a href="#">Link Building Services</a>
                  <a href="#">Guest Post Services</a>
                  <a href="#">Digital PR Agency</a>
                </div>

                <div className="dropdown-section">
                  <h3>E-Commerce SEO</h3>
                  <a href="#">E-Commerce SEO</a>
                  <a href="#">Shopify SEO</a>
                  <a href="#">Drupal SEO</a>
                  <a href="#">Magento SEO</a>
                </div>

                <div className="dropdown-section">
                  <h3>AI SEO</h3>
                  <a href="#">SearchGPT SEO</a>
                  <a href="#">AEO Services</a>
                </div>

                <div className="dropdown-section">
                  <h3>Industry SEO</h3>
                  <a href="#">SEO For Lawyers</a>
                  <a href="#">SEO For Immigration</a>
                  <a href="#">SEO For Doctors</a>
                  <a href="#">SEO For Real Estate</a>
                  <a href="#">View All Industries</a>
                </div>

                {/* <div className="dropdown-cta">
                  <h3>Get Free SEO Audit</h3>
                  <p>
                    A Free SEO Audit analyses your website's SEO performance,
                    highlighting issues in keywords, page speeds, mobile
                    functions, and site structure. It provides actionable
                    insights to boost rankings and traffic.
                  </p>
                  <a href="#" className="cta-button">
                    Talk to SEO Expert Now
                  </a>
                </div> */}
              </div>
            )}
          </div>

          <div
            className="nav-item-with-dropdown"
            onMouseEnter={() => !isMobile && setDigitalDropdownOpen(true)}
            onMouseLeave={() => !isMobile && setDigitalDropdownOpen(false)}
          >
            <a
              href="#seo"
              onClick={toggleDigitalDropdown}
              aria-expanded={digitalDropdownOpen}
              aria-haspopup="true"
            >
              DIGITAL MARKETING ▼{" "}
              {isMobile && isOpen && (
                <span className="dropdown-indicator">
                  {digitalDropdownOpen ? "−" : "+"}
                </span>
              )}
            </a>
            {digitalDropdownOpen && (
              <div className="seo-dropdown">
                <div className="dropdown-section">
                  <h3>Paid Marketing</h3>
                  <a href="#">Google Ads/ PPC Services</a>
                  <a href="#">Amazon PPC Marketing</a>
                </div>

                <div className="dropdown-section">
                  <h3>Custom Digital Marketing</h3>
                  <a href="#">Product Marketings</a>
                  <a href="#">Faceless Digital Marketing</a>
                  <a href="#">Shopify Digital Marketing</a>
                  <a href="#">Franchise Digital Marketing</a>
                </div>

                <div className="dropdown-section">
                  <h3>Social Media Marketing</h3>
                  <a href="#">Social Media Services</a>
                  <a href="#">Influncer Marketing</a>
                </div>

                <div className="dropdown-section">
                  <h3>Design and Development</h3>
                  <a href="#">Web Design Services</a>
                  <a href="#">Custom Landing Page</a>
                  <a href="#">App Store Marketing</a>
                </div>

                <div className="dropdown-section">
                  <h3>Content Marketing</h3>
                  <a href="#">Content Writing and Marketing</a>
                  <a href="#">Copywriting Service</a>
                </div>

                <div className="dropdown-section">
                  <h3>Hire Experts</h3>
                  <a href="#">Hire Digital Marketer</a>
                </div>

                {/* <div className="dropdown-cta">
                  <h3>Get Free SEO Audit</h3>
                  <p>
                    A Free SEO Audit analyses your website's SEO performance,
                    highlighting issues in keywords, page speeds, mobile
                    functions, and site structure. It provides actionable
                    insights to boost rankings and traffic.
                  </p>
                  <a href="#" className="cta-button">
                    Talk to SEO Expert Now
                  </a>
                </div> */}
              </div>
            )}
          </div>
          {/* <a href="#case">CASE STUDIES</a> */}
          <a href="/about-us">ABOUT</a>
          <a href="/blogs">BLOG</a>
          <a href="/faq">FAQ</a>
          <a href="/contact-us">CONTACT</a>
          <div className="cta-buttons">
            <a href="tel:+912269710459" className="cta-button phone">
              +91-2269710459
            </a>
            <a href="#portal" className="cta-button portal" onClick={() => setShowLoginPopup(true)}>
              Client Console
            </a>
          </div>
        </nav>
        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
          aria-expanded={isOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {showLoginPopup && (
        <LoginPopup onClose={() => setShowLoginPopup(false)} />
        )}
    </>
  );
};

export default Header;
